// Complete trading glossary — 35 curated terms, translated by RE₿EL LLM pipeline (Sprint B).
// Category and id keys preserved from ES for cross-locale color/lookup consistency.

export const GLOSARIO = [
  {
    id: "order-block",
    termino: "Order Block (OB)",
    categoria: "Smart Money",
    definicion: "Preiszone, in der institutionelle Anleger (Smart Money) bedeutende Orders platziert haben. Sie wird als die letzte bärische Kerze vor einem starken bullischen Impuls (bullischer OB) oder die letzte bullische Kerze vor einem starken bärischen Impuls (bärischer OB) identifiziert. Der Preis tendiert dazu, zu diesen Niveaus zurückzukehren und sie zu testen.",
    ejemplo: "Wenn BTC plötzlich von 40K auf 45K steigt, ist die letzte rote Kerze vor diesem Impuls ein bullischer Order Block. Wenn der Preis in diese Zone zurückkehrt, werden institutionelle Anleger Positionen hinzufügen.",
    relacionados: [
      "fair-value-gap",
      "imbalance",
      "liquidity"
    ]
  },
  {
    id: "fair-value-gap",
    termino: "Fair Value Gap (FVG)",
    categoria: "Smart Money",
    definicion: "Ungleichgewicht oder Ineffizienz im Preis, die entsteht, wenn sich der Markt so schnell bewegt, dass eine Lücke zwischen dem oberen Docht einer Kerze und dem unteren Docht der nächsten besteht (bei einem bullischen Impuls). Der Markt tendiert dazu, diese Gaps aufgrund des Prinzips des Preisgleichgewichts wieder zu füllen.",
    ejemplo: "Wenn Kerze 1 einen oberen Docht bei 42.000 hat und Kerze 3 einen unteren Docht bei 42.500, gibt es ein FVG zwischen 42.000 und 42.500. Der Preis wird wahrscheinlich zurückkehren, um es zu füllen.",
    relacionados: [
      "order-block",
      "imbalance",
      "bos"
    ]
  },
  {
    id: "imbalance",
    termino: "Imbalance / Ungleichgewicht",
    categoria: "Smart Money",
    definicion: "Bereich im Chart, in dem sich der Preis so schnell bewegte, dass kein Gleichgewicht zwischen Käufern und Verkäufern bestand. Ähnlich wie FVG, aber auf verschiedene Zeitrahmen anwendbar. Ungleichgewichte wirken wie Magnete für den Preis.",
    relacionados: [
      "fair-value-gap",
      "order-block"
    ]
  },
  {
    id: "bos",
    termino: "Break of Structure (BOS)",
    categoria: "Smart Money",
    definicion: "Bruch der Marktstruktur. Tritt auf, wenn der Preis das vorherige Hoch in einem Aufwärtstrend überschreitet (oder das vorherige Tief in einem Abwärtstrend durchbricht) und damit die Fortsetzung des Trends bestätigt. Es unterscheidet sich vom CHoCH, da es die aktuelle Richtung bestätigt.",
    ejemplo: "Aufwärtstrend: BTC bildet steigende Hochs und Tiefs. Wenn der Preis das letzte Hoch überschreitet, ist das ein BOS, der bestätigt, dass der Trend anhält.",
    relacionados: [
      "choch",
      "tendencia"
    ]
  },
  {
    id: "choch",
    termino: "Change of Character (CHoCH)",
    categoria: "Smart Money",
    definicion: "Charakterwechsel des Marktes. Erstes Signal, dass der aktuelle Trend sich ändern könnte. In einem Aufwärtstrend tritt der CHoCH auf, wenn der Preis das letzte relevante Tief nach unten durchbricht. Es ist die erste Warnung, bevor der BOS die Umkehr bestätigt.",
    relacionados: [
      "bos",
      "tendencia"
    ]
  },
  {
    id: "liquidity",
    termino: "Liquidität (Liquidity)",
    categoria: "Smart Money",
    definicion: "Im Kontext von Smart Money ist Liquidität die Ansammlung von Stop-Loss-Orders unterhalb von Tiefs oder oberhalb von Hochs. Institutionelle benötigen Liquidität, um ihre großen Orders zu füllen, weshalb der Preis häufig diese Niveaus jagt (Stop Hunts), bevor er sich in die tatsächliche Richtung bewegt.",
    ejemplo: "Wenn viele Trader Stop-Loss bei 40.000 haben (unterhalb einer Unterstützung), können Institutionelle den Preis kurz unter 40K drücken, um diese Stops auszulösen, die Liquidität einzusammeln und dann zu steigen.",
    relacionados: [
      "order-block",
      "inducement"
    ]
  },
  {
    id: "inducement",
    termino: "Inducement (IDM)",
    categoria: "Smart Money",
    definicion: "Liquiditätsfalle. Bewegung, die darauf ausgelegt ist, Retail-Trader in eine falsche Position zu locken, bevor die echte Bewegung erfolgt. Der Preis bildet ein falsches Hoch oder Tief, das wie ein guter Einstiegspunkt aussieht, aber in Wirklichkeit Liquidität einsammelt.",
    relacionados: [
      "liquidity"
    ]
  },
  {
    id: "premium-discount",
    termino: "Premium- und Discount-Zonen",
    categoria: "Smart Money",
    definicion: "Der Preis im Verhältnis zur aktuellen Range. Die Premium-Zone (oberhalb von 50% der Range) ist teuer zum Kaufen — Institutionelle verkaufen hier. Die Discount-Zone (unterhalb von 50%) ist günstig — Institutionelle kaufen hier. Fibonacci 50% als Referenz verwenden.",
    relacionados: [
      "fibonacci",
      "order-block"
    ]
  },
  {
    id: "soporte",
    termino: "Unterstützung",
    categoria: "Análisis Técnico",
    definicion: "Preisniveau, bei dem Käufer historisch die Verkäufer übertroffen haben und Rückgänge gestoppt oder umgekehrt wurden. Je öfter der Preis von diesem Niveau abgeprallt ist, desto stärker ist die Unterstützung. Wird sie durchbrochen, wird die Unterstützung zum Widerstand.",
    ejemplo: "BTC ist im letzten Monat 4 Mal bei 40.000 abgeprallt. Dieses Niveau ist eine starke Unterstützung.",
    relacionados: [
      "resistencia",
      "tendencia"
    ]
  },
  {
    id: "resistencia",
    termino: "Widerstand",
    categoria: "Análisis Técnico",
    definicion: "Preisniveau, bei dem Verkäufer historisch die Käufer übertroffen haben und Anstiege gestoppt oder umgekehrt wurden. Wird er mit Volumen durchbrochen, wird der Widerstand zur Unterstützung.",
    relacionados: [
      "soporte",
      "tendencia"
    ]
  },
  {
    id: "tendencia",
    termino: "Trend",
    categoria: "Análisis Técnico",
    definicion: "Vorherrschende Richtung der Preisbewegung über einen Zeitraum. Aufwärtstrend: steigende Hochs und Tiefs. Abwärtstrend: fallende Hochs und Tiefs. Seitwärtstrend: Preis oszilliert in einer Range ohne klare Richtung.",
    relacionados: [
      "bos"
    ]
  },
  {
    id: "vela-japonesa",
    termino: "Japanische Kerze (Candlestick)",
    categoria: "Análisis Técnico",
    definicion: "Grafische Darstellung des Preises in einem Zeitraum. Der Körper zeigt die Differenz zwischen Eröffnung und Schluss. Die Dochte (Schatten) zeigen das Hoch und Tief des Zeitraums. Grün/weiß = Schluss höher als Eröffnung (bullish). Rot/schwarz = Schluss niedriger als Eröffnung (bearish).",
    relacionados: [
      "doji",
      "martillo"
    ]
  },
  {
    id: "doji",
    termino: "Doji",
    categoria: "Análisis Técnico",
    definicion: "Kerze mit sehr kleinem Körper (Eröffnung ≈ Schluss) und Dochten auf beiden Seiten. Signal für Unentschlossenheit des Marktes. Besonders relevant auf Unterstützungs-/Widerstandsniveaus oder nach einer ausgedehnten Bewegung. Kann einer Umkehr vorausgehen.",
    relacionados: [
      "vela-japonesa",
      "martillo"
    ]
  },
  {
    id: "martillo",
    termino: "Hammer",
    categoria: "Análisis Técnico",
    definicion: "Kerze mit kleinem Körper im oberen Bereich und langem unteren Docht (mindestens 2x der Körper). Signal für bullische Umkehr, wenn sie nach einem Abwärtstrend erscheint. Zeigt an, dass Käufer niedrigere Preise stark abgelehnt haben.",
    relacionados: [
      "doji",
      "vela-japonesa"
    ]
  },
  {
    id: "volumen",
    termino: "Volumen",
    categoria: "Análisis Técnico",
    definicion: "Anzahl der in einem Zeitraum gehandelten Vermögenswerte. Das Volumen bestätigt Preisbewegungen. Ein bullischer Impuls mit hohem Volumen ist zuverlässiger als einer mit niedrigem Volumen. Divergenz zwischen Preis und Volumen kann Erschöpfung signalisieren.",
    relacionados: [
      "rsi"
    ]
  },
  {
    id: "fibonacci",
    termino: "Fibonacci-Retracement",
    categoria: "Análisis Técnico",
    definicion: "Werkzeug, das die Fibonacci-Verhältnisse (23,6%, 38,2%, 50%, 61,8%, 78,6%) verwendet, um mögliche Unterstützungs-/Widerstandsniveaus innerhalb eines Retracements zu identifizieren. Die Niveaus 61,8% (goldener Schnitt) und 50% werden am häufigsten verwendet. In SMC trennt das 50%-Niveau Premium von Discount.",
    relacionados: [
      "premium-discount",
      "soporte"
    ]
  },
  {
    id: "rsi",
    termino: "RSI (Relative Strength Index)",
    categoria: "Análisis Técnico",
    definicion: "Momentum-Indikator, der die Geschwindigkeit und Veränderung von Preisbewegungen auf einer Skala von 0 bis 100 misst. Über 70: überkauft. Unter 30: überverkauft. Die RSI-Preis-Divergenz ist ein starkes Signal für eine mögliche Umkehr.",
    relacionados: [
      "macd"
    ]
  },
  {
    id: "macd",
    termino: "MACD",
    categoria: "Análisis Técnico",
    definicion: "Moving Average Convergence Divergence. Trend- und Momentum-Indikator. Besteht aus der MACD-Linie (EMA12 - EMA26), der Signallinie (EMA9 des MACD) und dem Histogramm. Die Kreuzung der MACD-Linie über die Signallinie erzeugt Kauf-/Verkaufssignale.",
    relacionados: [
      "rsi",
      "ema"
    ]
  },
  {
    id: "ema",
    termino: "EMA (Media Móvil Exponencial)",
    categoria: "Análisis Técnico",
    definicion: "Gleitender Durchschnitt, der aktuellen Daten mehr Gewicht verleiht und schneller auf Preisänderungen reagiert als der SMA. Die am häufigsten verwendeten EMAs im Krypto-Bereich: 20, 50, 100 und 200. Preis über EMA200 = Aufwärtstrend. Darunter = Abwärtstrend.",
    relacionados: [
      "macd",
      "tendencia"
    ]
  },
  {
    id: "stop-loss",
    termino: "Stop Loss",
    categoria: "Gestión de Riesgo",
    definicion: "Automatische Order zum Schließen einer Position, wenn der Preis ein vordefiniertes Verlustniveau erreicht. Das wichtigste Werkzeug des Traders. Schützt das Kapital vor ungünstigen Bewegungen. Handle NIEMALS ohne Stop Loss.",
    ejemplo: "Du kaufst BTC zu 45.000. Du setzt den Stop Loss bei 43.500. Wenn der Preis auf 43.500 fällt, wird die Position automatisch geschlossen und dein Verlust auf 1.500€ oder den von dir berechneten Prozentsatz begrenzt.",
    relacionados: [
      "take-profit",
      "ratio-rr"
    ]
  },
  {
    id: "take-profit",
    termino: "Take Profit (TP)",
    categoria: "Gestión de Riesgo",
    definicion: "Automatische Order zum Schließen einer Position, wenn der Preis ein vordefiniertes Gewinnziel erreicht. Ermöglicht das Sichern von Gewinnen ohne ständige Marktbeobachtung.",
    relacionados: [
      "stop-loss",
      "ratio-rr"
    ]
  },
  {
    id: "ratio-rr",
    termino: "Ratio R:R (Risiko/Ertrag)",
    categoria: "Gestión de Riesgo",
    definicion: "Verhältnis zwischen dem eingegangenen Risiko (Abstand zum Stop) und der potenziellen Belohnung (Abstand zum Ziel). Ein R:R von 1:2 bedeutet, dass du das Doppelte dessen gewinnst, was du riskierst. Mindestempfehlung: 1:2. Profis streben 1:3 oder höher an.",
    ejemplo: "Stop Loss 500€ vom Einstieg, Take Profit 1.500€ vom Einstieg → R:R = 1:3. Mit 40% Trefferquote bist du noch profitabel.",
    relacionados: [
      "stop-loss",
      "take-profit"
    ]
  },
  {
    id: "drawdown",
    termino: "Drawdown",
    categoria: "Gestión de Riesgo",
    definicion: "Maximaler Rückgang vom Kapitalhöchststand bis zum darauffolgenden Tiefpunkt. Wenn dein Konto 15.000€ erreicht und dann auf 12.000€ fällt, beträgt der Drawdown 20%. Die Kontrolle des maximalen Drawdowns ist entscheidend für das langfristige Überleben.",
    relacionados: [
      "gestion-capital"
    ]
  },
  {
    id: "gestion-capital",
    termino: "Kapitalmanagement",
    categoria: "Gestión de Riesgo",
    definicion: "Die Gesamtheit der Regeln, die bestimmen, wie viel Kapital bei jedem Trade riskiert wird. Die 1-2%-Regel besagt, nicht mehr als 1-2% des Gesamtkapitals pro Trade zu riskieren. Das ist der Unterschied zwischen Tradern, die bestehen bleiben, und denen, die ihre Konten sprengen.",
    relacionados: [
      "drawdown",
      "stop-loss"
    ]
  },
  {
    id: "halving",
    termino: "Bitcoin-Halving",
    categoria: "Cripto",
    definicion: "Im Bitcoin-Code programmiertes Ereignis, das alle 210.000 Blöcke (~4 Jahre) stattfindet und die Belohnung, die Miner für jeden Block erhalten, halbiert. Reduziert das neue BTC-Angebot. Historisch ging es wichtigen Bull Runs voraus. Die Halvings fanden 2012, 2016, 2020 und 2024 statt.",
    relacionados: []
  },
  {
    id: "altcoin-season",
    termino: "Altcoin Season",
    categoria: "Cripto",
    definicion: "Zeitraum, in dem Altcoins (Kryptowährungen außer Bitcoin) die Performance von BTC deutlich übertreffen. Tritt in der Regel auf, wenn BTC sich nach einem starken Anstieg konsolidiert und Kapital in Projekte mit höherem Risiko/Ertrag rotiert.",
    relacionados: [
      "dominancia-btc"
    ]
  },
  {
    id: "dominancia-btc",
    termino: "Bitcoin-Dominanz",
    categoria: "Cripto",
    definicion: "Prozentsatz des gesamten Kryptowährungsmarktes, den Bitcoin repräsentiert. Hohe Dominanz (>60%) = Kapital konzentriert in BTC = konservativer Markt. Niedrige Dominanz (<40%) = Kapital rotiert zu Altcoins = Altcoin Season.",
    relacionados: [
      "altcoin-season"
    ]
  },
  {
    id: "defi",
    termino: "DeFi (Dezentralisierte Finanzen)",
    categoria: "DeFi",
    definicion: "Ökosystem von Finanzanwendungen, die auf Blockchain aufgebaut sind und ohne Intermediäre operieren. Umfasst dezentralisierte Börsen (DEX), Kreditprotokolle, Yield Farming, Liquiditätspools. Smart Contracts ersetzen Banken.",
    relacionados: [
      "amm"
    ]
  },
  {
    id: "amm",
    termino: "AMM (Automated Market Maker)",
    categoria: "DeFi",
    definicion: "Dezentrales Marktprotokoll, das mathematische Algorithmen (in der Regel x*y=k) zur Preisfestlegung verwendet, anstelle eines traditionellen Orderbuchs. Uniswap, Curve und PancakeSwap sind die bekanntesten.",
    relacionados: [
      "defi"
    ]
  },
  {
    id: "cpi",
    termino: "CPI (Verbraucherpreisindex)",
    categoria: "Macro",
    definicion: "Inflationsmaß, das die Preisänderung eines Warenkorbs von Gütern und Dienstleistungen verfolgt. Ein höher als erwarteter CPI übt in der Regel Abwärtsdruck auf Risikoanlagen aus (einschließlich Krypto), da er Zinserhöhungen durch die Fed antizipiert.",
    relacionados: [
      "fed"
    ]
  },
  {
    id: "fed",
    termino: "Reserva Federal (Fed)",
    categoria: "Macro",
    definicion: "Zentralbank der Vereinigten Staaten. Ihre Zinsentscheidungen beeinflussen alle globalen Märkte einschließlich Krypto. Zinserhöhung = teureres Geld = weniger Investitionen in Risikoanlagen = Krypto-Rückgang. Zinssenkung = gegenteiliger Effekt.",
    relacionados: [
      "cpi"
    ]
  },
  {
    id: "fomo",
    termino: "FOMO (Fear Of Missing Out)",
    categoria: "Psicología",
    definicion: "Angst, eine Bewegung zu verpassen. Führt dazu, dass der Trader spät in Positionen einsteigt (nach einem großen Anstieg), hohe Preise zahlt und enge Stop-Loss setzt. Eine der häufigsten Ursachen für Verluste im Krypto-Bereich. Das Gegenmittel: einen klaren Trading-Plan haben und diesem folgen.",
    relacionados: [
      "revenge-trading",
      "overtrading"
    ]
  },
  {
    id: "revenge-trading",
    termino: "Revenge Trading",
    categoria: "Psicología",
    definicion: "Impulsives Handeln nach einem Verlust mit dem Ziel, das verlorene Geld schnell zurückzugewinnen. Verursacht die größten Verluste, weil Entscheidungen aus Emotionen heraus getroffen werden, nicht aus der Strategie. Das Gegenmittel: nach einem Verlust pausieren und dem Plan folgen.",
    relacionados: [
      "fomo",
      "overtrading"
    ]
  },
  {
    id: "overtrading",
    termino: "Overtrading (Sobreoperación)",
    categoria: "Psicología",
    definicion: "Übermäßiges Handeln, bei dem mehr Trades eingegangen werden, als der Markt rechtfertigt. Meist motiviert durch Langeweile, Euphorie oder Verzweiflung. Erhöht Gebühren, reduziert die Qualität der Setups und erschöpft psychologisch. Qualität vor Quantität.",
    relacionados: [
      "fomo",
      "revenge-trading"
    ]
  }
];

// GLOSARIO_CATEGORIAS keeps ES tokens as canonical keys — labels are
// resolved at render time via labelCategoria(cat, "de") from i18n-academy.js.
// Rows below preserve `categoria` in ES for filter-equality + tailwind color map.
export const GLOSARIO_CATEGORIAS = [
  "Smart Money",
  "Análisis Técnico",
  "Gestión de Riesgo",
  "Cripto",
  "DeFi",
  "Macro",
  "Psicología",
];
